import { BasicObject } from './checkout.interface';

export interface Scoring {
    global: BasicObject;
    detaille: BasicObject;
    avc?: number;
}

export enum ScoringActions {
    LINK = 'lien',
    EDP = 'supprimerEdp',
}

export enum YounitedReason {
    CANCEL = 'ANNULER',
    REFUSED = 'REFUSER',
}
